import { render, staticRenderFns } from "./Official.vue?vue&type=template&id=6c76497b&scoped=true&"
import script from "./Official.vue?vue&type=script&lang=js&"
export * from "./Official.vue?vue&type=script&lang=js&"
import style0 from "./Official.vue?vue&type=style&index=0&id=6c76497b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c76497b",
  null
  
)

export default component.exports